module.exports = __webpack_public_path__ + "static/media/mini-panda-resumen.b8b1b000.png";